<template>
  <div class="web-container">
    <!--页面顶部-->
    <a href="#" name="index"></a>
    <div class="content-container page-header">
      <div class="flex flex-dr flex-center">
        <div class="web-title flex flex-dr flex-center">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <span class="title">{{ webConfig.schoolName }}</span>
          <span class="title">{{ webConfig.systemName }}</span>
        </div>
      </div>
    </div>
    <!--顶部导航-->
    <nut-tabbar
        @tab-switch="tabSwitch3"
        :tabbar-list="navList"
        :bottom="true"
    >
    </nut-tabbar>
    <!--轮播图-->
    <div class="focus-container ">
      <nut-swiper class="swiper"
                  direction="horizontal"
                  :loop="true"
                  :autoPlay="2000"
                  :canDragging="false"
                  :paginationVisible="true"
                  ref="demo2"
      >
        <div v-for="(item,index) in webConfig.focusList" :key="index" class="nut-swiper-slide">
          <img :src="item" class="nut-img" alt=""/>
        </div>

      </nut-swiper>
    </div>
    <!--中心介绍-->
    <a href="#" name="center"></a>
    <div class="li-container content-container">
      <el-divider content-position="center" class="content-title">中心介绍</el-divider>
      <div class="content-html html-view">
        建设中
      </div>
    </div>
    <!--项目介绍-->
    <a href="#" name="experiment"></a>
    <div class="content-container experiment-container">
      <el-divider content-position="center" class="content-title">项目介绍</el-divider>
      <!--实验介绍-->
      <div class="experiment-container flex flex-dr flex-center">
        <div class="list flex flex-dr flex-center">
          <div class="li" v-for="(experiment,experimentIndex) in experiments.list">
            <img :src="experiment.product_iconLeft" alt="" class="left-icon" v-if="experiment.product_iconLeft"
                 style="z-index: 1">
            <div class="bg">
              <img :src="experiment.product_bg" alt="">
            </div>
            <div class="info">
              <img class="avatar" :src="experiment.product_icon" alt="">
              <div class="title">{{ experiment.name }}</div>
              <div class="des-main word-hr ellipsis">{{ experiment.subName }}</div>
              <!--最多3行 每行18字 第三行超出省略号显示-->
              <div class="des word-hr ellipsis" v-html="experiment.description"></div>
              <div class="buttons">
                <a class="button" @click="ExperimentMethods().clickViewExperiment(experiment)">查看详情</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品介绍弹窗-->
    <nut-popup position="bottom" get-container="body" v-model="experimentInfo.dialog" :destroy-on-close="true" closeable
               close-icon="cross" close-icon-position="top-right"
               :style="{ height: '80%' }">
      <div class="experiment-dialog">
        <div class="header flex flex-dr flex-center"
             :style='"background-image: url("+experimentInfo.experiment.product_info_bg+")"'>
          <img :src="experimentInfo.experiment.product_icon" alt="" class="avatar">
          <div class="title">{{ experimentInfo.experiment.name }}</div>
          <div class="series-name">{{ experimentInfo.experiment.seriesName }}</div>
        </div>
        <div class="info-box">
          <div class="des">
            <div>实验简介：</div>
            <div class="view">
              <p v-for="p in experimentInfo.experiment.experimentDescription.split('\n')">{{ p }}</p>
            </div>
          </div>
          <div class="view-box">
            <!--todo 封面问题安卓和ios解决-->
            <div class="video-box" v-if="experimentInfo.experiment.product_video">
              <video id="v1" loop="" preload="auto" muted="" x-webkit-airplay="true" airplay="allow"
                     :poster="experimentInfo.experiment.name==='飞夺泸定桥'?'http://resouce.cdzyhd.com/6adb4edc-9226-4119-8419-366daff7e26a.png':''"
                     webkit-playsinline="true" playsinline="true" :src="experimentInfo.experiment.product_video"
                     class="video1 video"
                     draggable="true"></video>
              <img src="@/assets/icon/play.png" alt="" class="play-btn"
                   @click="e=>ExperimentMethods().playVideo(e)">
              <!--todo 加入全屏按钮-->
            </div>
            <el-image v-if="!experimentInfo.experiment.product_video&&experimentInfo.experiment.sample!==true" class="video-box-no" fit="cover"
                      :src="experimentInfo.experiment.product_info_img"
                      @click="window.open(experimentInfo.experiment.product_info_img)"></el-image>
            <div class="img-box flex flex-around flex-wrap" v-if="experimentInfo.experiment.sample!==true">
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_1)"
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_1">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_2)"
                  class="img"
                  fit="cover"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_2">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_3)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_3">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_4)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_4">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </nut-popup>
    <!--团队介绍-->
    <a href="#" name="member"></a>
    <div class="member-container content-container" v-if="false">
      <el-divider content-position="center" class="content-title">教学团队</el-divider>
      <div class="member-list">
        <nut-tab>
          <nut-tab-panel tab-title="思德法教研室">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[0]['list']" @click="clickMember(item,index)">
                <el-image
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </nut-tab-panel>
          <nut-tab-panel tab-title="概论教研室">
            <div class="avatar-list flex flex-start flex-wrap">
              <div class="avatar-li" v-for="(item,index) in memberList[1]['list']" @click="clickMember(item,index)">
                <el-image
                    :src="item.avatar"
                    fit="scale-down"></el-image>
                <div class="name">{{ item.name }}（{{ item.duty }}）</div>
              </div>
            </div>
          </nut-tab-panel>
        </nut-tab>
      </div>
    </div>
    <nut-popup position="bottom" get-container="body" v-model="member.dialog" :style="{ height: '80%' }"
               :destroy-on-close="true" closeable
               close-icon="cross" close-icon-position="top-right">
      <el-descriptions direction="vertical" :column="4" border class="member-dialog">
        <el-descriptions-item label="现任职务" :span="4">{{ member.info.duty }}</el-descriptions-item>
        <el-descriptions-item label="主授课程" :span="4">{{ member.info.course }}</el-descriptions-item>
        <el-descriptions-item label="研究方向" :span="4">{{ member.info.direction }}</el-descriptions-item>
        <el-descriptions-item label="主要社会兼职" :span="4">{{ member.info.socialDuty }}</el-descriptions-item>
        <el-descriptions-item label="简历" :span="4">
          <div v-html="member.info.history" class="word-hr history"></div>
        </el-descriptions-item>
        <el-descriptions-item label="承担课题/研究成果" :span="4">
          <div v-html="member.info.success" class="word-hr success"></div>
        </el-descriptions-item>
      </el-descriptions>
    </nut-popup>
    <!--友情链接-->
    <a href="#" name="link"></a>
    <div class="link-container content-container">
      <el-divider content-position="center" class="content-title">友情链接</el-divider>
      <div class="list flex flex-around flex-wrap">
        <div v-for="item in linkConfig.list" v-if="item.img" @click="clickLink(item)">
          <el-image :src="item.img" alt="" class="li" fit="contain"></el-image>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!--底部-->
    <div class="page-footer">
      <div class="info-container content-container">
        <div class="infos">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <p>{{ webConfig.webName }}</p>
          <p>主办：{{ webConfig.collegeName }}</p>
          <p>技术支持</p>
          <p>成都智云鸿道信息技术有限公司 </p>

          <p style="cursor: pointer" @click="window.open('https://beian.miit.gov.cn/')">{{
              webConfig.beiAnText
            }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elDragDialog from "@/directive/el-drag-dialog";
import {isMobile, shareStart} from "../../utils/common";
import {WEB_URL} from "../../model/ConfigModel";
import {OfficialWebExperimentModel} from "../../model/OfficialWebExperimentModel";

export default {
  name: "web_xjnyzyjsxy",
  directives: {
    elDragDialog
  },
  components: {},
  data() {
    return {
      window: window,
      navIndex: "",
      webConfig: {
        "logoUrl":"http://resouce.cdzyhd.com/250a90eb-be6d-4c17-8340-87ef65b22700.webp",
        "indexBannerUrl": "http://116.63.187.43:7035/files/20220720/216212798869344256.jpeg",
        "schoolName": "成都航空职业技术学院",
        "collegeName": "成都航空职业技术学院马克思主义学院",
        systemName: "思政课虚拟仿真体验教学中心",
        "focusList": [
          "http://resouce.cdzyhd.com/3c4f86b4-ee48-48a5-bbe2-0945fd4104d9.png",
          "http://resouce.cdzyhd.com/419c4e33-a189-420b-be9b-31e7c10bf329.jpg",
          "http://resouce.cdzyhd.com/1922d40e-9d1f-4176-84cd-74918a080b9b.jpg",
        ],
        "webName": "成都航空职业技术学院思政课虚拟仿真体验教学中心",
        beiAnText: "蜀ICP备19034784号-1"
      },
      introduceConfig: {
        "tabs": [{
          "name": "中心简介",
          "showNav": true,
          "text": "",
          "id": "1661264029372"
        }, {
          "name": "教学团队",
          "showNav": true,
          "text": "",
          "id": "1661264039431"
        }], "name": "中心介绍"
      },
      experiments: {
        list: [
          {
            "id": 1680004842153,
            "name": "习近平新时代中国特色社会主义思想概论",
            "subName": "讲述西海固人民在福建对口帮扶下，将飞",
            "subName_h5": "讲述西海固人民在福建对口帮扶下，将飞沙走石的“干沙滩”建设",
            "description": "讲述西海固人民在福建对口帮扶下，将飞沙走石的“干沙滩”建设成寸土寸金的“金沙滩”；德胜村在总书记指示下，将扶贫产业发展作",
            "experimentDescription": "讲述西海固人民在福建对口帮扶下，将飞沙走石的“干沙滩”建设成寸土寸金的“金沙滩”；德胜村在总书记指示下，将扶贫产业发展作为治本之策，因地制宜探索精准脱贫的有效途径；时代楷模黄文秀积极响应党的号召，毅然决定投身脱贫攻坚“大战场”中，把生命定格在脱贫路上；华阳湖有序推进环境整治和生态修复，昔日“臭水塘”华丽蜕变成国家湿地公园等故事。\n通过本项目，借助于案例式、沉浸式交互体验，让学员对习近平新时代中国特色社会主义思想具备更直观、更深刻的理解，自觉用党的科学理论武装头脑。",
            "product_bg": "http://resouce.cdzyhd.com/04806c43-1ed5-46f3-83a1-72613318f406.png",
            "product_icon": "http://resouce.cdzyhd.com/f64a9345-f861-45ac-9602-cac219f77f35.png",
            "product_info_bg": "http://resouce.cdzyhd.com/8e93d089-1d87-4d5b-87b5-ae5bee9a92f5.png",
            "product_info_img": "http://resouce.cdzyhd.com/18600941-679d-45f3-9f9b-a3de030cbe36.png",
            "product_info_img_1": "http://resouce.cdzyhd.com/f0290fe9-95cd-4510-90f0-ebdf198dcbb0.png",
            "product_info_img_2": "http://resouce.cdzyhd.com/0380eb78-a2d3-4fe0-9aa1-d9f6b7b502c2.png",
            "product_info_img_3": "http://resouce.cdzyhd.com/1ea185df-97d0-4f43-8a63-43a118d13d8b.png",
            "product_info_img_4": "http://resouce.cdzyhd.com/07c1379d-0c53-4c29-80b2-f2441c3e6205.jpg"
          },
          {
            "id": 1618400683877,
            "name": "四渡赤水",
            "subName": "四渡赤水战役是遵义会议之后，中央红军",
            "description": "四渡赤水战役是遵义会议之后，中央红军在长征途中，处于国民党几十万重兵围追堵截的艰险条件下，毛泽东指挥中央红军三个月的时间",
            "experimentDescription": "四渡赤水战役是遵义会议之后，中央红军在长征途中，处于国民党几十万重兵围追堵截的艰险条件下，毛泽东指挥中央红军三个月的时间六次穿越三条河流，转战川黔滇三省，巧妙地穿插于国民党军重兵集团围剿之间，不断创造战机，在运动中大量歼灭敌人，取得红军长征史上以少胜多，变被动为主动的光辉战例。\n在本项目中，学员以第一人称的视角化身渡河红军，通过取舍过河物资，安全穿越河流，体验红军四渡赤水的艰难条件。在体验过程中，学员还可选择多种武器击落飞机，过程惊险刺激，让学员充分感受当年红军飞渡赤水河艰苦卓绝的环境和顽强战斗的精神。",
            "product_icon": "http://resouce.cdzyhd.com/07733789-03ca-40cb-9626-bf7585451f34.png",
            "product_info_bg": "http://resouce.cdzyhd.com/b7517d4f-b148-4216-82a1-180b8f2e52ca.jpg",
            "product_info_img_1": "http://resouce.cdzyhd.com/1db23db7-a0a3-4ccb-b830-f7dfae0b1e2a.jpg",
            "product_info_img_2": "http://resouce.cdzyhd.com/ecd9fe3b-ad68-42e9-8ce1-5e6c28d6aa50.jpg",
            "product_info_img_3": "http://resouce.cdzyhd.com/10f517db-9885-4abd-8b5f-4eae2f04c68b.jpg",
            "product_info_img_4": "http://resouce.cdzyhd.com/b6f0fcf3-17ec-49fa-b4c9-06a2723055fe.jpg",
            "product_bg": "http://resouce.cdzyhd.com/4702694c-3fb4-41b3-82f5-ac7fbf039785.jpg",
            "product_info_img": "http://resouce.cdzyhd.com/bd62a0ec-96f4-42f4-b459-2896069f5db7.jpg",
            "subName_h5": "通过取舍过河物资，安全穿越河流，体验红军四渡赤水的艰难条件"
          },
          {
            "id": 1618400078717,
            "name": "彝海结盟",
            "subName": "彝海结盟讲述了1935年5月，时任红",
            "description": "彝海结盟讲述了1935年5月，时任红军总参谋长兼先遣军司令员刘伯承和彝族果基家支头人小叶丹以水代酒，“彝海结盟”。此后彝",
            "experimentDescription": "彝海结盟讲述了1935年5月，时任红军总参谋长兼先遣军司令员刘伯承和彝族果基家支头人小叶丹以水代酒，“彝海结盟”。此后彝族同胞护送红军历经七天七夜通过彝区。不仅为红军强渡大渡河、飞夺泸定桥赢得了宝贵时间，也在彝区埋下了革命火种，帮助彝族人民建立了革命武装——中国夷（彝）民红军沽鸡（果基）支队。\n通过参与交互式实验的方式使学员深入了解红军万里长征中彝海结盟的这一重要历史事件和过程，理解红军长征的艰苦及彝海结盟的历史意义，认识到彝海结盟是中国共产党的民族政策的一次成功实践和重要胜利，它为党在革命胜利后制定民族政策提供了重要参考。",
            "product_info_img_1": "http://resouce.cdzyhd.com/fa718c70-3d43-4f68-8903-83832e4cc854.jpg",
            "product_info_img_2": "http://resouce.cdzyhd.com/b000e424-9079-4734-8311-72a976c96710.jpg",
            "product_info_img_3": "http://resouce.cdzyhd.com/d8f30411-e578-4cc0-9d42-252e04692637.jpg",
            "product_info_img_4": "http://resouce.cdzyhd.com/67c0ffa0-b290-4341-80fd-803924bce854.jpg",
            "product_info_img": "http://resouce.cdzyhd.com/1bd0d43e-807a-4bc6-8625-1ee445c72c4e.png",
            "product_info_bg": "http://resouce.cdzyhd.com/fe00ed7e-879c-4fad-9601-217126f054fa.jpg",
            "product_icon": "http://resouce.cdzyhd.com/e02a07a2-b4b4-463e-8f81-61b63e0b6b37.png",
            "product_bg": "http://resouce.cdzyhd.com/212c1434-b9ea-4d96-8701-e577a34af46e.jpg",
            "subName_h5": "体验彝海结盟的事件过程，理解长征的艰苦及彝海结盟的历史意义"
          },
          {
            "id": 1617350115033,
            "name": "飞夺泸定桥",
            "subName": "1935年5月25日，中央红军部队在",
            "description": "1935年5月25日，中央红军部队在安顺场强渡大渡河后，陷入进退两难的尴尬局面——要想用仅有的几只小船将数万红军渡过河去",
            "experimentDescription": "1935年5月25日，中央红军部队在安顺场强渡大渡河后，陷入进退两难的尴尬局面——要想用仅有的几只小船将数万红军渡过河去，最快也需要一个月时间。红军首长当即作出了飞夺泸定桥的指示。这一仗，成为中国工农红军长征路上最为精彩的经典战斗之一。\n\n在本项目中，学员穿越时空置身于水流湍急的大渡河畔，时而在崇山峻岭中行进，时而化身成22勇士与守桥敌人展开浴血奋战，在枪林弹雨中，和战友们抓紧锁链，奋勇向前，身临其境地感受当年红军浴血奋战的长征场景。",
            "product_bg": "http://resouce.cdzyhd.com/546a3972-8223-49a7-8f02-12ac941cedaf.png",
            "product_icon": "http://resouce.cdzyhd.com/a5105425-e234-422b-8d95-a69b7c761b5f.png",
            "product_iconLeft": "",
            "product_info_bg": "http://resouce.cdzyhd.com/5798c6d5-ffd0-46c2-b171-87352d972e8a.jpg",
            "product_video": "http://resouce.cdzyhd.com/7b400fc4-5e4d-443e-85dc-15610d501b46.mp4",
            "product_info_img_1": "http://resouce.cdzyhd.com/d120f8cf-742c-4350-8ad2-be2381184521.jpg",
            "product_info_img_2": "http://resouce.cdzyhd.com/3674554e-25cb-4d26-860a-037a8732efdf.jpg",
            "product_info_img_3": "http://resouce.cdzyhd.com/41c31df2-a320-44e4-8ef1-64b1c6ed78cf.jpg",
            "product_info_img_4": "http://resouce.cdzyhd.com/7d067e83-3eb1-4b79-ae12-18224fa0771a.jpg",
            "product_info_img": "http://resouce.cdzyhd.com/d604295e-50e8-4022-81ee-2781d8e0f0a4.jpg",
            "subName_h5": "化身22勇士与敌人展开死斗，在枪林弹雨中抓紧锁链奋勇向前"
          },
          {
            "id": 1618399838791,
            "name": "爬雪山过草地",
            "subName": "爬雪山过草地是长征中自然环境最艰难的",
            "description": "爬雪山过草地是长征中自然环境最艰难的一段历程，英勇的红军不但用坚定意志征服了人类生存极限，而且模范执行党的民族政策，赢得",
            "experimentDescription": "爬雪山过草地是长征中自然环境最艰难的一段历程，英勇的红军不但用坚定意志征服了人类生存极限，而且模范执行党的民族政策，赢得了少数民族同胞的支持。\n在本项目中，学员化身的红军需要提前准备足够的棉衣和御寒的烧酒等物资，切身体验红军战士置身陡峭雪山、茫茫草地上艰苦跋涉的场景。通过实验，感悟和学习红军伟大的爱国主义精神，增强中华民族守望相助的大团结观念，真切感受政治建设是党的根本建设，坚定维护党中央权威和集中统一领导。",
            "product_bg": "http://resouce.cdzyhd.com/fc8b7c1b-0f58-48c1-8ec7-47f5eed33f60.png",
            "product_icon": "http://resouce.cdzyhd.com/ed0eff27-08b6-4bce-801b-105069e39a67.png",
            "product_info_bg": "http://resouce.cdzyhd.com/95395dec-1b6f-493b-842b-348b23f5922e.jpg",
            "product_info_img": "http://resouce.cdzyhd.com/0d84c2dc-74d8-4b29-b374-41a3dd2cff66.jpg",
            "product_info_img_1": "http://resouce.cdzyhd.com/50c8dd28-d45e-494c-ae73-50054f8e6910.jpg",
            "product_info_img_2": "http://resouce.cdzyhd.com/25c05d17-6c24-4157-9c83-e5ee1882e74e.jpg",
            "product_info_img_3": "http://resouce.cdzyhd.com/85ff577a-c3ec-4403-8880-53b357506f2f.jpg",
            "product_info_img_4": "http://resouce.cdzyhd.com/1a5ed918-b5f4-46ab-83f6-7b95be8e97b2.jpg",
            "subName_h5": "体验英勇无畏的红军置身陡峭雪山、茫茫草地上艰苦跋涉的场景"
          },
          {
            "id": 1644387517358,
            "name": "两弹一星",
            "subName": "“两弹”中的一弹是原子弹，后来演变为",
            "subName_h5": "了解新中国成立初期的国际局势和两弹一星研制成功的发展历程",
            "description": "“两弹”中的一弹是原子弹，后来演变为原子弹和氢弹的合称；另一弹是指导弹。“一星”则是人造地球卫星。",
            "experimentDescription": "20世纪50年代、60年代是极不寻常的时期，当时面对严峻的国际形势，为抵制帝国主义的武力威胁和核讹诈，以毛泽东同志为核心的第一代党中央领导集体，根据当时的国际形势，为了保卫国家安全作出独立自主研制“两弹一星”的战略决策。大批优秀的科技工作者，包括许多在国外已经有杰出成就的科学家，以身许国，怀着对新中国的满腔热爱，响应党和国家的召唤，义无反顾地投身到这一神圣而伟大的事业中来。\n通过实验让学员们了解新中国成立初期的国际局势，领会中共中央领导集体的高瞻远瞩，以及“为了避免战争，必须准备战争”的国家安全战略；学习掌握我国“两弹一星”从研制、试验到获得成功的发展历程，激发浓厚的爱国热情与民族自豪感；弘扬并传承 “两弹一星”精神，深刻体会我国老一辈科学家和社会主义建设者们“热爱祖国、无私奉献，自力更生、艰苦奋斗，大力协同、勇于登攀” 的崇高品质。",
            "product_bg": "http://resouce.cdzyhd.com/42e6268d-ec23-4a3b-8720-8660d5e606d1.jpg",
            "product_icon": "http://resouce.cdzyhd.com/659811c9-0cc6-43cb-8d87-85f1fb5f29e2.jpg",
            "product_info_bg": "http://resouce.cdzyhd.com/4b14f7d2-245e-4090-8e41-3d0d6873cbb3.jpg",
            "product_info_img": "http://resouce.cdzyhd.com/6945dfbd-4710-4be3-98ff-a4f0c91fb5f9.jpg",
            "product_info_img_1": "http://resouce.cdzyhd.com/974cf07a-a234-46d8-95ad-75379757cbcf.jpg",
            "product_info_img_2": "http://resouce.cdzyhd.com/e1efd745-fdb8-4698-b7d1-1afa7842e41b.jpg",
            "product_info_img_3": "http://resouce.cdzyhd.com/674ad1c2-c34a-4aaa-8bb6-6b1f39d2de0f.jpg",
            "product_info_img_4": "http://resouce.cdzyhd.com/7391a928-a579-4266-86cb-112a41be250c.jpg"
          },
          {
            "id": 1666665227109,
            "name": "汶川大地震",
            "subName": "2008年的汶川大地震，让世界都看到",
            "subName_h5": "2008年的汶川大地震，让世界都看到了中国人民的团结，无论",
            "description": "2008年的汶川大地震，让世界都看到了中国人民的团结，无论是救援部队亦或是前线记者，甚至是受灾民众展现出来的团结和超强的",
            "experimentDescription": "2008年的汶川大地震，让世界都看到了中国人民的团结，无论是救援部队亦或是前线记者，甚至是受灾民众展现出来的团结和超强的行动力令国外震惊。\n\n本项目还原汶川大地震中第一队空降兵的救援经历，让学员在虚拟环境中，通过交互任务、生死选择等方式体验当时的救援场景，并依托所学的理论和知识进行科学分析和理性判断，从而全方位地认识汶川大地震，增强历史共情和民族自豪感，自觉投身中华民族伟大复兴的历史伟业。",
            "product_bg": "http://resouce.cdzyhd.com/613d6fe7-bb00-46ad-aae6-860fdede773a.jpeg",
            "product_icon": "http://resouce.cdzyhd.com/f4bc409d-082f-45f0-802d-77d785b296d3.jpg",
            "product_info_bg": "http://resouce.cdzyhd.com/661aee31-d6b9-461e-a8d2-2e04c44885fe.jpeg",
            "product_info_img": "http://resouce.cdzyhd.com/e5573aa5-d1fb-4624-885e-d756422bc15f.jpeg",
            "product_info_img_1": "http://resouce.cdzyhd.com/3315d54f-f0b1-425e-8d75-4d130e1fdd82.jpeg",
            "product_info_img_2": "http://resouce.cdzyhd.com/c2a894fc-9664-4f95-870a-3a2ef47d1055.jpeg",
            "product_info_img_3": "http://resouce.cdzyhd.com/d0134afe-e8b1-4fe9-a34f-c9a011408931.jpeg",
            "product_info_img_4": "http://resouce.cdzyhd.com/eaaffbdd-298f-415e-8967-8c708197fda9.jpeg"
          }
        ]
      },
      experimentInfo: {
        dialog: false,
        experiment: {
          experimentDescription: ""
        },
        list: []
      },
      experimentDialogPicList: [],
      memberActive: "1",
      memberList: [],
      member: {
        dialog: false,
        info: {}
      },
      linkConfig: {
        list: [
          {
            "id": 1661270247796,
            "img": "http://resouce.cdzyhd.com/5c89e07b-bf1c-44fb-8498-b5875e3ca27b.jpg",
            "name": "成都航空职业技术学院",
            "url": "https://www.cap.edu.cn/"
          },
          {
            "id": 1662270247796,
            "img": "http://resouce.cdzyhd.com/d23cf15e-2e72-4e9f-8777-b23f55fb824c.png",
            "name": "成都智云鸿道",
            "url": "http://www.cdzyhd.com/"
          }
        ]
      },
      navList: [
        {
          'tabTitle': '中心介绍',
          'curr': false,
          'icon': 'http://img13.360buyimg.com/uba/jfs/t1/10361/35/4713/4643/5c0f3d62E437a3c94/273fd0fb90798f03.jpg',
          'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/26604/35/1073/7896/5c0f3d61Eb9f5f184/5f01c938abe4216d.jpg',
          'href': '#center'
        },
        {
          'tabTitle': '项目介绍',
          'curr': false,
          'icon': 'http://img12.360buyimg.com/uba/jfs/t1/25443/23/1062/4600/5c0f3d61E2e9f1360/c9b3421fe18614e2.jpg',
          'activeIcon': 'http://img20.360buyimg.com/uba/jfs/t1/19241/12/1048/8309/5c0f3d61E17ed5a56/c3af0964cade47f8.jpg',
          'href': '#experiment'
        },
        // {
        //   'tabTitle': '体验教学系统',
        //   'curr': false,
        //   'icon': 'http://resouce.cdzyhd.com/4c482680-6607-4c92-8dc4-4d36a7d73787.png',
        //   'activeIcon': 'http://resouce.cdzyhd.com/5d968a97-eefe-4058-8c0e-b5192ea4d7b6.png',
        //   'href': 'http://exp.cdzyhd.com/login?schoolId=258950417977708544'
        // },
        // {
        //   'tabTitle': '教学团队',
        //   'curr': false,
        //   'icon': 'http://img20.360buyimg.com/uba/jfs/t1/20004/20/1045/3620/5c0f3d61Eaaec1670/9e59db63983b7b9f.jpg',
        //   'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/23967/14/1072/6714/5c0f3d61E0ad8991e/8f741953f6e38f15.jpg',
        //   'href': '#member'
        // },
        {
          'tabTitle': '友情链接',
          'curr': false,
          'icon': 'http://resouce.cdzyhd.com/28d7cdf5-9c34-47e9-84dc-527e93cc0244.png',
          'activeIcon': 'http://resouce.cdzyhd.com/1e72c019-f242-4404-9467-fd14d4f69b24.png',
          'href': '#link'
        },
      ]
    }
  },
  created() {
    // 判断是不是在移动端
    if (!isMobile()) {
      window.location.href = WEB_URL + this.$route.path
    }
  },
  mounted() {
    this.getExperimentConfig()
    document.title = "成都航空职业技术学院思政课虚拟仿真体验教学中心"
    // 配置微信分享参数
    setTimeout(() => {
      // 判断是否在微信内
      // 思政教育春风化雨，立德树人启智润心更多精彩思政资源
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
        shareStart(window.location.href, "成都航空职业技术学院思政课虚拟仿真体验教学中心", "习近平新时代中国特色社会主义思想概论、飞夺泸定桥、四渡赤水、彝海结盟、爬雪山过草地、两弹一星、汶川地震", "http://h5.exp.cdzyhd.com/images/logo/cdhkzyjsxy.png")
      }
    }, 500)
  },
  methods: {
    // 获取产品配置
    async getExperimentConfig() {
      // 要获取的实验列表，和自定义属性
      let experimentList = [
        {id: "1680005596593", name: "习近平新时代中国特色社会主义思想概论"},
        {id: "1618400683877", name: "四渡赤水"},
        {id: "1618400078717", name: "彝海结盟"},
        {id: "1617350115033", name: "飞夺泸定桥"},
        {id: "1618399838791", name: "爬雪山过草地"},
        {id: "1644387517358", name: "两弹一星"},
        {id: "1666665227109", name: "汶川大地震"},
      ]
      let list = []
      for (let i = 0; i < experimentList.length; i++) {
        let id = experimentList[i]["id"]
        let experiment = await OfficialWebExperimentModel.getOneExperimentConfig(id)
        let experimentLast=Object.assign({},experiment,experimentList[i])
        // 合并自定义项
        list.push(experimentLast)
        this.$set(this.experiments, "list", list)
      }
    },
    tabSwitch3: function (value, index) {
      console.log(index);
    },
    // 点击首页导航
    selectNav(v) {
      switch (v) {
        case "1":
          window.location.href = "#center"
          break;
        case "2":
          window.location.href = "#experiment"
          break;
        case "3":
          window.location.href = "#member"
          break;
        case "4":
          window.location.href = "#link"
          break;
        case "5":
          window.location.href = ""
          break;
      }
    },
    // 点击团队成员
    clickMember(item, index) {
      this.$set(this.member, "info", item)
      this.member.dialog = true
    },
    // 点击友情链接
    clickLink(item) {
      window.open(item.url)
    },
    // 实验项目方法集
    ExperimentMethods() {
      let $this = this;
      return {
        clickViewExperiment(experiment) {
          $this.experimentInfo.dialog = true
          $this.experimentDialogEnterBtn = false
          $this.$set($this.experimentInfo, "experiment", experiment);
          $this.experimentDialogPicList = [
            experiment.product_info_img_1,
            experiment.product_info_img_2,
            experiment.product_info_img_3,
            experiment.product_info_img_4,
          ]
          if (!experiment.product_video && experiment.product_info_img) {
            $this.experimentDialogPicList.push(experiment.product_info_img)
          }
          setTimeout(() => {
            $(".experiment-dialog .bg").css("background-image", `url(${experiment.product_info_bg})`)
          }, 100)
        },
        // 播放视频
        playVideo(e) {
          // this.videoPlay = true
          // document.querySelector("#v1").play()
          $this.experimentInfo.experimentVideoDialog = true
        }
      }
    }
  }
}
</script>
<style>
.nut-tab {
  padding: 0px !important;
  border: 0px !important;
  overflow-y: hidden;
}

.nut-tab-item {
  height: auto !important;
  padding: 0px !important;
}

.nut-tab-link {
  font-size: 27px !important;
}

.nut-tabbar .tabbar-nav:nth-child(3) .tabbar-nav-word {
  color: #de201a !important;
}
</style>
<style scoped lang="less">
@import '../../style/app.less';

.web-container {
  //background-color: #f2f2f2;
}

.content-title {
  margin-top: 40px;

  .el-divider__text {
    font-size: 40px;
    color: #777;
    font-weight: 450;
    text-align: center;
    margin-bottom: 20px;
  }

}

.page-header {
  width: 100%;
  background-color: #fff;
  z-index: 1999;

  .web-title {
    margin-top: 20px;

    .logo {
      width: 150px;
      height: 150px;
      cursor: pointer;
      display: block;
      margin-bottom: 15px;
    }

    span.title {
      font-size: 40px;
      color: #666;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}

.focus-container {
  margin-top: 30px;
  margin-bottom: 60px;

  .swiper {
    height: 550px;
  }

  .nut-img {
    object-fit: cover;
    height: 550px;
  }
}

.li-container {
  margin-bottom: 50px;

  .content-html {
    margin-top: 45px;
    padding: 0px 20px;
    text-indent: 2em;
    font-size: 28px;
    color: #666;
    line-height: 40px;
    letter-spacing: 3px;
  }
}

// 实验介绍
.experiment-container {
  margin-bottom: 100px;

  .main-title {
    margin-top: 83px;
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    color: #333333;
  }

  .title-des {
    font-size: 28px;
    font-weight: 300;
    line-height: 37px;
    color: #333333;
    margin-top: 20px;
    margin-bottom: 60px;
  }

  .list {
    width: 670px;
    align-items: normal;

    .li {
      margin-bottom: 40px;
      position: relative;

      &:hover {
        .bg {
          img {
            transition: all 0.5s linear;
            transform: scale(1.1);
          }
        }

        .info {
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

          .avatar {
            margin-top: -40px;
            opacity: 0;
          }

          .des-main {
            opacity: 0;
          }

          .title {
            margin-top: -60px;
          }

          .des {
            display: -webkit-box;
          }

          .buttons {
            display: block;
          }
        }
      }

      img.left-icon {
        position: absolute;
        width: 120px;
        height: 120px;
        top: -10px;
        left: -10px;
        z-index: 10;
      }

      .bg {
        z-index: 1;
        width: 670px;
        height: 413px;
        overflow: hidden;

        img {
          width: 670px;
          height: 413px;
          display: block;
          transition: all 0.5s linear;
          transform: scale(1);
        }
      }

      .info {
        position: relative; // 解决margin-top负数 和同级div的z-index问题
        padding: 30px;
        height: 415px;
        width: 590px;
        margin: 0 auto;
        margin-top: -60px;
        text-align: center;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-bottom: 3px solid transparent;
        transition: all 0.2s linear;

        .avatar {
          display: inline-block;
          width: 148px;
          height: 148px;
          position: relative;
          margin-top: 60px;
          transition: all 0.2s linear;
          box-shadow: 1px 3px 6px 2px #dedede;
        }

        .title {
          position: relative;
          font-size: 33px;
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 8px;
          transition: all 0.2s linear;
          line-height: 46px;
        }

        .des-main {
          font-size: 28px;
          line-height: 35px;
          transition: all 0.2s linear;
          color: #666;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .des {
          font-weight: 300;
          font-size: 29px;
          display: none;
          color: #666;
          line-height: 35px;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .buttons {
          display: none;
          text-align: center;
          margin-top: 15px;
        }

        .button {
          display: inline-block;
          width: 200px;
          line-height: 56px;
          border: 1px solid #d8d8d8;
          border-radius: 15px;
          text-align: center;
          font-size: 24px;
          color: #666666;
          position: relative;
          cursor: pointer;
          transition: all 0.2s linear;
          text-decoration: none;
          padding: 5px 20px;
          margin-top: 20px;

          &:hover {

          }
        }


      }
    }

    .li:last-child {
      margin-bottom: 0px;
    }
  }

  .more {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s linear;
    width: 300px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #707070;

    &:hover {
      transform: scale(1.1);
    }

    span {
      font-weight: 400;
      line-height: 21px;
      color: #999999;
      font-size: 32px;

    }

    i {
      margin-left: 10px;
    }
  }
}

.experiment-dialog {
  .header {
    width: 750px;
    height: 530px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;

    .avatar {
      width: 178px;
      height: 178px;
    }

    .title {
      margin-top: 10px;
      font-size: 32px;
      font-weight: bold;
      line-height: 42px;
      color: #FFFFFF;
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
    }

    .series-name {
      font-size: 28px;
      font-weight: 400;
      line-height: 37px;
      color: #FFFFFF;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
      margin-top: 10px;
    }

  }

  .info-box {
    padding: 20px 40px;
    font-size: 28px;
    font-weight: 400;
    line-height: 37px;
    color: #333333;

    .view {
      margin-top: 10px;
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
      text-indent: 2em;
    }

    .view-box {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 65px;

      .video-box {
        width: 670px;
        height: 360px;
        position: relative;

        video {
          position: absolute;
          left: 0;
          top: 0;
          width: 670px;
          height: 360px;
          object-fit: fill;
          z-index: 1;
        }

        .play-btn {
          position: absolute;
          // 上下左右居中
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 108px;
          height: 108px;
          cursor: pointer;
          z-index: 2;
        }
      }

      .video-box-no {
        width: 670px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
      }

      .img-box {
        margin-top: 10px;

        .img {
          width: 330px;
          height: 105px;
          cursor: pointer;

          &:nth-child(1), &:nth-child(2) {
            margin-bottom: 11px;
          }
        }
      }
    }
  }
}

.member-list {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 55px;
  width: 100%;

  .title {
    margin-bottom: 20px;
    color: #555;
    font-size: 25px;
  }

  .avatar-list {
    padding-top: 20px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 360px);

    .avatar-li {
      width: 360px;
      margin-bottom: 30px;

      .el-image {
        width: 360px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
        opacity: 1;
        transform: scale(1);
        cursor: pointer;
      }

      .name {
        width: 360px;
        text-align: center;
        margin-top: 15px;
        color: #888;
        font-size: 26px;
      }
    }
  }
}

.member-dialog {
  text-align: left;
  font-size: 28px;
  color: #888;
}

// 友情链接
.link-container {
  margin-bottom: 45px;
  padding: 0px 30px;

  .list {
    margin-top: 60px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 320px);
    grid-gap: 10px;

    .name {
      margin-top: 10px;
      color: #777;
      font-size: 26px;
    }
  }


  .li {
    width: 320px;
    height: 160px;
    margin-top: 10px;
    //margin-right: 10px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;
    opacity: 1;
    transform: scale(1);
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      transition: all 0.3s linear;
      transform: scale(1.03);
    }
  }
}

.page-footer {
  background-color: #2d2d2d;
  padding: 20px 0px;
  padding-bottom: 35px;
  margin-bottom: 135px;

  .info-container {
    .logo {
      width: 70px;
      height: 70px;
      cursor: pointer;
      display: none;
    }

    .infos {
      text-align: center;
      color: @remark-color;
      font-size: 24px;

      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
